import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import Tooltip from 'components/Tooltip'
import CheckBox from 'components/CheckBox'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import { Formik } from 'formik'

import {
  Form,
  Row,
  Column,
  SubTitle,
  InfoText,
  ErrorContainer,
  AccessLevelBlock
} from './styles'

export default function AddAccessLevelsModal ({
  visible,
  professional,
  accessLevels = [],
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const filteredAccessLevels = accessLevels.filter (al => (
    !professional.access_levels.some (pal => pal.id === al.id)
  ))

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Adicionar níveis de acesso</DialogTitle>
        </DialogHeader>
        <Formik
          initialValues={{
            'access_levels': filteredAccessLevels.map (accessLevel => ({
              ...accessLevel,
              selected: false
            }))
          }}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              setErrorMessage (null)
              const selectedLevels = values.access_levels.filter (level => level.selected)

              await cutileiApi.post (
                `/businesses/${businessId}/professionals/${professional.id}/access_levels`,
                { access_levels: selectedLevels },
                requestConfig
              )

              setSubmitting (false)
              handleConfirm (selectedLevels)
              handleClose ()
            } catch (error) {
              setSubmitting (false)
              logApiError (error)
            }
          }}
        >
          {({
            values,
            isSubmitting,
            setFieldValue,
            handleSubmit
          }) => {
            const levelSelected = values.access_levels.some(level => level.selected)

            return (
              <>
                <DialogBody>
                  <Form onSubmit={handleSubmit} onKeyDown={submitOnEnter(handleSubmit, isSubmitting || !levelSelected)}>
                    <InfoText>
                      Selecione os níveis de acesso que deseja atribuir a este(a) profissional.
                    </InfoText>
                    <Column>
                      {values.access_levels.map ((accessLevel, index) => (
                        <AccessLevelBlock
                          key={index}
                          selected={accessLevel.selected}
                          onClick={() => setFieldValue (`access_levels.${index}.selected`, !accessLevel.selected)}
                          style={{margin: 0}}
                        >
                          <Row>
                            <CheckBox
                              id={accessLevel.id}
                              value={accessLevel.selected}
                              onValueChange={value => setFieldValue (`access_levels.${index}.selected`, value)}
                            />
                            <SubTitle>
                              {accessLevel.name}
                            </SubTitle>
                          </Row>
                          <Row>
                            <Tooltip
                              id={accessLevel.id}
                              message={accessLevel.description}
                              labelStyle={{width: 300}}
                              place='bottom'
                            />
                            <InfoText>
                              {accessLevel.permissions.length}
                              {accessLevel.permissions.length === 1 ? ' Permissão' : ' Permissões'}
                            </InfoText>
                          </Row>
                        </AccessLevelBlock>
                      ))}
                    </Column>
                    {errorMessage && (
                      <ErrorContainer>
                        <p>{errorMessage}</p>
                      </ErrorContainer>
                    )}
                  </Form>
                </DialogBody>
                {levelSelected && (
                  <DialogFooter>
                    <Row>
                      <MainButton
                        type='button'
                        label='Confirmar alteração'
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        loading={isSubmitting}
                        width={180}
                      />
                    </Row>
                  </DialogFooter>
                )}
              </>
            )
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
